import { useNLE as useEirSalesNLE } from "@modules/eirSalesFacade/swr/nle";
import { IEirSalesNle } from "@modules/eirSalesFacade/interfaces/models/IEirSalesNLE";
import { EEirSalesNLEStatus } from "@modules/eirSalesFacade/constants";

interface IParams {
    prequalId: string;
}

export const useNLE = (props: IParams) => {
    const { prequalId } = props;
    const { data, error, mutate } = useEirSalesNLE(prequalId, {
        refreshInterval: (nle: IEirSalesNle | undefined): number => {
            if (!nle || nle.status === EEirSalesNLEStatus.PENDING) {
                return 3000;
            }

            return 0;
        },
    });

    const isPending = (!data && !error) || data?.status === EEirSalesNLEStatus.PENDING;

    const nleError = error || data?.status === EEirSalesNLEStatus.ERROR;

    return { nle: data, error: nleError, isPending, mutate };
};
